<script setup lang="ts">
const _props = defineProps<{
  data: CenteredMediaProps
  sectionIndex: number
  template?: 'overlay' | 'page'
}>()

const videoProps = computed(() => ({
  controls: _props.data.media?.video && _props.data.showVideoControls,
  autoplay: !_props.data.media?.video || !_props.data.showVideoControls,
  muted: !_props.data.media?.video || !_props.data.showVideoControls,
  loop: !_props.data.media?.video || !_props.data.showVideoControls,
}))
</script>

<template>
  <section
    class="xl:gap-gap flex place-content-center items-center max-xl:aspect-[8/9] xl:grid xl:h-screen xl:grid-cols-12"
    :class="{
      'bg-black': template !== 'page' && template !== 'overlay' && data.theme !== 'light-grey',
      'bg-light-grey':
        template === 'page' || (template !== 'overlay' && data.theme === 'light-grey'),
      'bg-white': template !== 'overlay' && data.theme === 'white',
    }"
  >
    <div
      class="max-xl:px-bleed flex w-full items-center justify-center xl:col-span-8 xl:col-start-3"
    >
      <CommonMedia
        :sizes="['100vw', '50vw']"
        class="h-[-webkit-fill-available] max-h-screen w-full"
        :fill="'both'"
        v-bind="{ ...data, ...videoProps }"
        :loading="sectionIndex === 0 ? 'eager' : 'lazy'"
      />
    </div>
  </section>
</template>
